const parseJsonResponse = async (response) => {
  const text = await response.text();

  if (!text) {
    return {};
  }

  try {
    return JSON.parse(text);
  } catch {
    return {};
  }
};

const buildApiError = async (response, fallbackMessage) => {
  const payload = await parseJsonResponse(response);
  return new Error(payload.error || fallbackMessage);
};

export const loginWithPin = async (pin) => {
  const response = await fetch("/api/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ pin }),
  });

  if (!response.ok) {
    throw await buildApiError(response, "Inloggen is niet gelukt.");
  }

  return true;
};

const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error(`Kon ${file.name} niet lezen.`));
    reader.readAsDataURL(file);
  });

export const publishProject = async ({ title, description, pin, images }) => {
  if (!pin) {
    throw new Error("Log eerst in met de pincode.");
  }

  const encodedImages = await Promise.all(
    images.map(async (image) => ({
      name: image.file.name,
      type: image.file.type,
      role: image.role,
      dataUrl: await fileToDataUrl(image.file),
    }))
  );

  const response = await fetch("/api/upload-project", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      pin,
      title,
      description,
      images: encodedImages,
    }),
  });

  if (response.status === 401) {
    throw new Error("De pincode klopt niet of is niet meer geldig.");
  }

  if (!response.ok) {
    throw await buildApiError(response, "Opslaan is niet gelukt.");
  }

  return parseJsonResponse(response);
};

const postWithPin = async (url, payload, fallbackMessage) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (response.status === 401) {
    throw new Error("De pincode klopt niet of is niet meer geldig.");
  }

  if (!response.ok) {
    throw await buildApiError(response, fallbackMessage);
  }

  return parseJsonResponse(response);
};

export const updateProject = async ({ pin, projectId, title, description }) =>
  postWithPin(
    "/api/update-project",
    { pin, projectId, title, description },
    "Project bijwerken is niet gelukt."
  );

export const deleteProject = async ({ pin, projectId }) =>
  postWithPin(
    "/api/delete-project",
    { pin, projectId },
    "Project verwijderen is niet gelukt."
  );
